export const makeRequestQuery = (query: Record<string, string | number | boolean>) => {
  if (Object.keys(query).length) {
    const queryString = Object.keys(query).map(key => key + '=' + query[key]).join('&');
    return `?${queryString}`;
  }

  return '';
};
